import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useDataAggregation } from '../../Common/hooks/useAggregationData';
import { useValuesChartsDataContext } from './hooks/useValuesChartsDataContext';
import { getMonthLabel } from '../../../Common/Util/getMonthLabel'

export const TransferValueComparisonMonthly = () => {
    const { chartData } = useValuesChartsDataContext();

    const rawData = chartData?.transferValueComparisonMonth || [];

    const series = [
        {
            name: 'Valor',
            data: rawData?.map(item => item.transfer_value)
        },
        {
            name: 'Diferença',
            data: rawData?.map(item => item.difference)
        },
        {
            name: 'Teto',
            data: rawData?.map(item => item.transfer_ceiling)
        }
    ];


    const isYearComparison = rawData.length > 0 && rawData.every(item => item.mes === rawData[0].mes);
    const formattedSubtitles = isYearComparison ? rawData.map(item => `${getMonthLabel(item.mes)}/${item.ano}`): rawData.map(item => getMonthLabel(item.mes));

    return (
        <SimpleBars
            title={'Comparação Valor de Repasse (Mensal)'}
            horizontal={false}
            subtitles={formattedSubtitles}
            series={series}
            stacked
            showDataLabels={false}
        />
    );
};